function roundNumber($filter) {
  'ngInject';
  return function(number, maxLimit, fractionSize) {

    maxLimit = maxLimit || 1000;
    fractionSize = fractionSize || 1;

    if (number >= maxLimit) {
      return '>' + $filter('number')(maxLimit);
    }

    if (number <= -maxLimit) {
      return '<' + $filter('number')(-maxLimit);
    }

    return $filter('number')(number, fractionSize);

  };
}
export { roundNumber };
